module.exports = __webpack_public_path__ + "images/team_avatar.503939c9d6f401f6f23a5514a7f63d7f.png";